import { FC, useEffect, useState } from "react"
import { FullWidthButton } from "src/framework/components/buttons";

interface FinanceiraButtonProperties {
    onClick: (newValue: boolean) => void,
    isChecked?: boolean,
    disabled?: boolean,
    text: string,
    color: "inherit" | "primary" | "secondary" | "default",
}
const FinanceiraButton: FC<FinanceiraButtonProperties> = ({
    onClick,
    disabled = false,
    isChecked,
    text,
    color = "default"
}) => {
    const [checked, setChecked] = useState<boolean>(false);


    useEffect(() => {
        setChecked(isChecked ? isChecked : false)
    }, [isChecked])

    return <div className="FinanceiraButton">
        <FullWidthButton
            text={text}
            color={color}
            disabled={disabled}
            disableElevation
            variant={checked ? "contained" : "outlined"}
            onClick={() => {
                const _checked = !checked;
                setChecked(_checked)
                onClick(_checked)
            }}
        />
    </div>
}

export { FinanceiraButton }